import { render, staticRenderFns } from "./donutChart.vue?vue&type=template&id=0e3645fc&scoped=true"
import script from "./donutChart.vue?vue&type=script&lang=js"
export * from "./donutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3645fc",
  null
  
)

export default component.exports